module.exports = __webpack_public_path__ + "img/ai-comic.19ed965c.webp";